import { TimesheetWorkedTimeBlockFragment } from 'generated/resources/graphql'
import groupBy from 'lodash/groupBy'

import { CustomTimeRangeCategoriesCollection } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

export const getOvertimeWorkedTimeBlocksByCategory = (
  workedTimeBlocks: TimesheetWorkedTimeBlockFragment[],
  timeSettingsCategories: CustomTimeRangeCategoriesCollection
) => {
  const timeBlocksByCategory = groupBy(workedTimeBlocks, (block) => block.timeRangeCategoryId)
  const overtimeCategories = timeSettingsCategories.overtimeAndAnyTimeCategories
  const categoryIds = Object.keys(timeBlocksByCategory)
  const categoryIdToNameMap = Object.fromEntries(
    overtimeCategories.map((cat) => [cat.id, cat.name])
  )
  const categoryNames = new Set(categoryIds.map((id) => categoryIdToNameMap[id]).filter(Boolean))
  return { timeBlocksByCategory, categoryNames }
}
